export const CATEGORIES = [
  "Career",
  "Relationships",
  "Health",
  "Money",
  "Education",
  "Family",
  "Friendships",
  "Mental / Emotional",
  "Opportunities Missed",
  "Self / Identity",
] as const;

export type Category = (typeof CATEGORIES)[number];

export const CATEGORY_SET = new Set(CATEGORIES);
